export default __webpack_public_path__ + "static/media/mobile3.cdac6011.jpg";